module.exports = __webpack_public_path__ + "static/media/Lakhwinderjit Singh.248ed29e.png";